<template>
    <div class="grid-manage-left">
        <el-button class="addBtn" type="primary" @click="addGirdArea">{{ $t('gridManage.addGridArea') }}</el-button>
        <el-input class="search" v-model="value" :placeholder="$t('gridManage.searchNamePlaceholder')" clearable>
            <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <div class="list">
            <YScroll style="height: 100%">
                <div
                    class="item"
                    :class="{ active: item.id === selectId }"
                    v-for="item in gridAreaLists"
                    :key="item.id"
                >
                    <div class="item-content" @click.stop="selectFn(item)">
                        <p>{{ $t('gridManage.name') }}：{{ item.name }}</p>
                        <div class="status" v-if="item.executeStatus !== undefined">
                            {{ $t('gridManage.status') }}：{{ statusFn(item) }}
                        </div>
                    </div>
                    <div class="btn">
                        <!-- <el-button type="text">编辑</el-button> -->
                        <a :href="`/sh_shared_uav/grid/info/downLoadGridFile?areaId=${item.areaId}`">
                            <el-button type="text">{{ $t('common.btnExport') }}</el-button>
                        </a>
                    </div>
                </div>
            </YScroll>
        </div>
        <Form ref="Form" :getGridList="getGridList"></Form>
    </div>
</template>

<script>
import { YScroll } from '@CommonComponent';
import api from '../api.js';
import Form from '../common/form.vue';

export default {
    props: ['gridList', 'getGridAreaList', 'selectFn', 'selectId', 'getGridList'],
    components: { Form, YScroll },
    data() {
        return {
            value: '',
            showForm: false,
            gridAreaLists: [],
        };
    },
    watch: {
        value: {
            handler(val) {
                this.changeGridAreaListByKeyValue(val);
            },
            immediate: true,
        },
        gridList() {
            this.gridAreaLists = this.gridList;
        },
    },
    methods: {
        changeGridAreaListByKeyValue(value) {
            if (value) {
                this.gridAreaLists = this.gridList.filter((item) => item.name.includes(value));
            } else {
                this.gridAreaLists = this.gridList;
            }
        },
        async downLoadGridFile(areaId) {
            await api.downLoadGridFile({ areaId }).run();
        },
        addGirdArea() {
            this.$refs.Form.showForm = true;
        },
        statusFn(item) {
            let str = '';
            if (item.executeStatus === 0) {
                str = this.$t('gridManage.flyable');
            }
            if (item.executeStatus === 1) {
                str = this.$t('gridManage.noFly');
            }
            if (item.executeStatus === 2) {
                str = this.$t('gridManage.disabled');
            }
            return str;
        },
    },
};
</script>

<style lang="scss" scoped>
.grid-manage-left {
    height: 100%;
    width: 320px;
    background-color: #f2f2f2;
    padding: 10px;
    box-sizing: border-box;
    .addBtn {
        width: calc(100% - 40px);
        height: 40px;
        margin: 0 auto;
        display: block;
    }
    .search {
        margin: 10px 0;
    }
    .list {
        height: calc(100% - 85px);
        .item {
            padding: 10px;
            margin-bottom: 10px;
            position: relative;
            height: 50px;
            background-color: #fff;
            .item-content {
                width: 220px;
                height: 50px;
                .status {
                    position: absolute;
                    bottom: 10px;
                    font-size: 14px;
                }
            }
            .btn {
                position: absolute;
                bottom: 0;
                right: 10px;
                z-index: 99;
                .el-button {
                    font-size: 16px;
                }
            }
            &.active {
                color: #409eff;
            }
        }
    }
}
</style>
